export { latinMap } from './latin-map';
export { TypeaheadOptions } from './typeahead-options.class';
export { TypeaheadMatch } from './typeahead-match.class';
export { TypeaheadUtils } from './typeahead-utils';
export { TypeaheadContainerComponent } from './typeahead-container.component';
export { TypeaheadDirective } from './typeahead.directive';
export { TypeaheadModule } from './typeahead.module';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ng2-bootstrap/typeahead/index.js
// module id = 683
// module chunks = 7